import React from 'react'

import { splitTextByMatch } from '~/components/HighlightedText/helpers'

type HighlightedTextProps = {
  /** The text to render */
  text: string
  /** Case-insensitive occurrences of this string are marked; blank renders unmarked */
  highlight?: string
}

/** Text with the case-insensitive occurrences of a search query marked */
export const HighlightedText = ({ text, highlight }: HighlightedTextProps) => {
  if (!highlight?.trim()) return <>{text}</>
  return (
    <>
      {splitTextByMatch(text, highlight).map((segment, index) =>
        segment.isMatch ? (
          <mark
            key={index}
            // Own text-fill so background-clip ancestors can't blank the glyphs
            className="rounded-sm bg-blue-500 text-white [-webkit-text-fill-color:currentcolor]"
          >
            {segment.text}
          </mark>
        ) : (
          <React.Fragment key={index}>{segment.text}</React.Fragment>
        ),
      )}
    </>
  )
}
